import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function ExportArchiveIcon(props, ref) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V6.5q0-.375.125-.675t.325-.575l1.4-1.7q.2-.274.5-.412T6 3h12q.35 0 .65.138.3.137.5.412l1.4 1.7q.2.275.325.575T21 6.5V19q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm.4-15h13.2l-.85-1H6.25zM5 19h14V8H5zm7-1.425q.2 0 .375-.062a.9.9 0 0 0 .325-.213l2.6-2.6a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275l-.9.9V11a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 10a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 11v3.2l-.9-.9a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7l2.6 2.6q.15.15.325.212.175.063.375.063"
    })
  });
}
;
ExportArchiveIcon.displayName = "ExportArchiveIcon";
export default forwardRef(ExportArchiveIcon);